import React, { Component } from 'react'
import { Filter, StudentRows } from './'

class ClassList extends Component {
  state = {
    filter: ''
  }

  onChg = ({target}) => this.setState({[target.name]: target.value}) 
  
  render() {
    const { inClass, notInClass, students, record } = this.props
    const { filter } = this.state
    const placeholder = `Search students ${notInClass ? 'not ' : ''} enrolled in this class...`
    return (
      <div>
        <div class="filter-placeholder">
          <div className="filter-placeholder-text"><strong>{placeholder}</strong></div>

          <Filter onChg={this.onChg} filter={filter} placeholder={placeholder}/>
        </div>
        <div class="student-rows">
          <StudentRows 
            filter={filter} 
            students={students} 
            record={record} 
            inClass={inClass}
            notInClass={notInClass}
          />

        </div>
      </div>
    )
  }
}

export default ClassList


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/AssignBlockComponents/ClassList.js